import ApiClient from "./ApiClient"

import PersonGroup  from "../types/PersonGroup"

export const PersonGroupApi = {

    apiPath: 'person-groups',

    get: async (id: number, include?: string): Promise<PersonGroup> => {

        let url: string = PersonGroupApi.apiPath + '/' + id

        if (include) {
            url += `?include=${include}`
        }

        const response = await ApiClient.get(url)

        return response.data.data
    },

    getAll: async (search?: string): Promise<PersonGroup[]> => {
        const items: PersonGroup[] = []
        const params = new URLSearchParams([
            ['lockingSystemId', localStorage.getItem('selectedLockingSystemId') as string]
        ])

        if (search) params.append('search', search)

        const response = await ApiClient.get(PersonGroupApi.apiPath, { params });

        for (let item of response.data.data) {
            items.push(item)
        }

        return items
    },

    add: async (newPersonGroup: PersonGroup, handleAddItem: (id: number) => void): Promise<PersonGroup> => {

        const result = await ApiClient.post(PersonGroupApi.apiPath, newPersonGroup);

        const itemRef = result.data.data;

        handleAddItem(itemRef.id);

        return result?.data.data
    },

    edit: async (personGroup: PersonGroup): Promise<PersonGroup> => {

        const result = await ApiClient.put(
            PersonGroupApi.apiPath + '/' + personGroup.id, personGroup
        );

        return result?.data.data
    },

    delete: async(id: number): Promise<any> => {

        return await ApiClient.delete(PersonGroupApi.apiPath + '/' + id);

    },
}